import SvgIcon from '@mui/material/SvgIcon'

export default function ExpandIcon(props) {
  return (
    <SvgIcon viewBox="0 0 30 30" sx={{ width: 30, height: 30 }} {...props}>
      <path d="M6 21h10v-2H6v2zm0-5h12v-2H6v2zm0-7v2h10V9H6zm11.59 9.59L21.17 15l-3.58-3.59L19 10l5 5-5 5-1.41-1.41z"/>
    </SvgIcon>
  )
}
